import orderService from "@/service/order.service";

export const state = {
	ordersReport: [],
	ordersPackagingReport: [],
}

export const mutations = {
	setOrdersResult(state, results) {
		state.ordersReport = results
	},

	setOrdersPackagingReport(state, results) {
		state.ordersPackagingReport = results
	},

}

export const actions = {

	async getOrdersResult({commit}, params) {
		commit('setOrdersResult', [])

		await orderService.getOrdersReport(params).then(async results => {
			commit('setOrdersResult', results)
		})
	},

	async getOrdersPackagingReport({commit}, params) {
		commit('setOrdersPackagingReport', [])

		await orderService.getOrdersReport(params).then(async results => {
			let filteredResults = results.filter(r=>r.verified)
			commit('setOrdersPackagingReport', filteredResults)
		})
	},

}


export default {
	state,
	actions,
	mutations,
};